export default {
  props: {
    isBottomPaddingShow: {
      type: Boolean,
      default: true
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    style: function style() {
      if (this.backgroundImage) {
        return {
          backgroundImage: "url('".concat(this.removeHttp(this.backgroundImage), "')")
        };
      } else {
        return {};
      }
    }
  }
};